import React from 'react';
import { Col, Row } from 'reactstrap';

const PHQ2Label = (props) => {
    return (
        <div className="w-100">
            <Row className="border-top-dotted border-color-muted border-bottom-dashed pb-2 ms-1 me-4">
                <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className={'border-end-dashed border-color-muted p-2'}>
                    {props.templateType === 'AHC-HRSN_Assessment_Info' && props.questionNumber + '.'} {props.questionText}{' '}
                    {props.isMandate && <span className="text-danger">*</span>}
                </Col>
                {props.answers?.length > 0
                    ? props.answers.map((item, index) => (
                          <Col
                              xs={12}
                              sm={12}
                              md={12}
                              lg={12}
                              xl={12}
                              xxl={12}
                              className={`p-2 d-flex justify-content-center ${
                                  props.answers?.length - 1 === index ? '' : ' border-end-dashed border-color-muted'
                              }`}
                              key={index}
                          >
                              <label className={'form-check-label pe-none ms-2 d-flex align-items-center'}>{item.answerText}</label>
                          </Col>
                      ))
                    : ''}
            </Row>
        </div>
    );
};

export default PHQ2Label;
